import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const c = r((e, a) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: a,
    ...e,
    image: (o) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "currentColor",
        viewBox: "0 0 48 48",
        ...o,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_4126",
              width: 32,
              height: 32,
              x: 8,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx("path", { d: "M31.53 8c-4.95 0-8.28 3.51-8.28 8.73v14.5c0 3.35-1.74 7.27-6.63 7.27-4.26 0-7.12-2.83-7.12-7.04 0-4.62 3.81-6.72 7.35-6.72 2.49 0 3.13.01 3.29.01h.11c.41-.01.74-.35.74-.76-.01-.43-.01-.61-.79-.69v-.04q-.09 0-.18.03c-.6-.04-1.58-.04-3.17-.04-4.4 0-8.85 2.82-8.85 8.22C8 36.49 11.54 40 16.62 40c5.62 0 8.13-4.41 8.13-8.77v-9.87c1.4 1.96 3.73 3.38 6.78 3.38 4.75 0 8.47-3.6 8.47-8.19C40 11.59 36.44 8 31.53 8m0 15.24c-4.4 0-6.78-3.35-6.78-6.51 0-4.39 2.66-7.23 6.78-7.23 4.1 0 6.97 2.9 6.97 7.04 0 3.76-3.06 6.7-6.97 6.7" }),
                /* @__PURE__ */ s.jsx("path", { d: "M32.836 21.77a5.56 5.56 0 1 0-2.555-10.821 5.56 5.56 0 0 0 2.555 10.822M16.43 37.25a5.56 5.56 0 1 0 0-11.12 5.56 5.56 0 0 0 0 11.12" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4126)", children: /* @__PURE__ */ s.jsx("path", { d: "M1.516 1.434h44.522v44.522H1.516z" }) })
        ]
      }
    )
  }
));
c.displayName = "AgencyCloggedPoresIcon";
export {
  c as AgencyCloggedPoresIcon,
  c as default
};
//# sourceMappingURL=index.js.map
